import { connect } from 'react-redux'
import Tracking from './Tracking'
import {
  getOrderListDetails,
  insertNetshoesLastEvent,
  loadProductsTracking
} from './actions'

const mapStateToProps = ({
  ordersTracking: { orderItems, loading, totalRows, tracking, hasMoreItems }
}) => {
  return {
    orderItems,
    totalRows,
    loading,
    tracking,
    hasMoreItems
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  getOrderDetails: (parentOrderId, orderId, productId) => {
    return dispatch(getOrderListDetails(null, orderId, null))
  },
  loadProductsTracking: (pageIndex, pageSize) => {
    return dispatch(loadProductsTracking(false, pageIndex, pageSize))
  },
  insertNetshoesLastEvent: (orderId, status) => {
    return dispatch(insertNetshoesLastEvent(orderId, status))
  }
})
export default connect(mapStateToProps, mapDispatchToProps)(Tracking)



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/TrackingContainer.js